/* eslint-disable no-unused-vars */
import React, { useState, useContext } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty } from 'lodash';
import { getTranslationByKey } from '../../helpers/translation-helper';
import { DWTCContext } from '../../utils/context';
import {
  WhatWeDoMobileWrapper,
  WhatWeDoMobileContainer,
  WhatWeDoMobileHeader,
  WhatWeDoMobileTabHeaderWrapper,
  WhatWeDoMobileTab,
  WhatWeDoMobileBody,
  WhatWeDoMobileContent,
  WhatWeDoMobileContentParagraph,
  WhatWeDoMobileContentImage,
} from '../styles/WhatWeDoTabs.styled';

export default function WhatWeDoMobile({ data, dir, id }) {
  const [activeTab, setActiveTab] = useState(0);
  const langDir = dir === 'ar' ? 'rtl' : 'ltr';
  const { translations } = useContext(DWTCContext);

  return (
    <WhatWeDoMobileWrapper id={id} className="smoothed">
      <WhatWeDoMobileContainer>
        <WhatWeDoMobileHeader>
          <h2 dir={dir}>{data.whatWeDoTabsTitle}</h2>
        </WhatWeDoMobileHeader>
        <WhatWeDoMobileBody>
          <WhatWeDoMobileTabHeaderWrapper>
          {isEmpty(data.whatWeDoTabsList) || (
              data.whatWeDoTabsList.map(({ content }, index) => (
                  <WhatWeDoMobileTab
                  key={index}
                  dir={dir}
                  onClick={() => setActiveTab(index)}
                  active={index === activeTab}
                  className={`${index === activeTab ? 'active-tab' : ''}`}
                  >
                    {getTranslationByKey(translations, content.tabBodyTitle)}
                  </WhatWeDoMobileTab>
              ))
          )}
          </WhatWeDoMobileTabHeaderWrapper>
          
          {!isEmpty(data.whatWeDoTabsList) &&
            data.whatWeDoTabsList.map((item, index1) => (
              <WhatWeDoMobileContent
                key={index1}
                className={`${activeTab === index1 ? 'active-tab' : ''}`}
              >
                <WhatWeDoMobileContentParagraph dir={dir}>
                  {item.content.tabBodyParagraphs.map((paragraph, index2) =>
                    !index2 ? <h3 dir={dir}>{paragraph}</h3> : <p dir={dir}>{paragraph}</p>,
                  )}
                </WhatWeDoMobileContentParagraph>
                <WhatWeDoMobileContentImage>
                  {!isEmpty(item.content.tabBodyImage) && (
                    <LazyLoadImage
                      src={item.content.tabBodyImage.url}
                      alt={item.content.tabBodyImage.alt}
                      className="width_100"
                      effect="blur"
                      placeholderSrc={
                        item.content.tabBodyImage
                          ? `${item.content.tabBodyImage.url}?width=50&quality=50`
                          : null
                      }
                    />
                  )}
                </WhatWeDoMobileContentImage>
              </WhatWeDoMobileContent>
            ))}
        </WhatWeDoMobileBody>
      </WhatWeDoMobileContainer>
    </WhatWeDoMobileWrapper>
  );
}
